import React from "react";
import { Field } from "formik";
import GridTable from "pages/_components/GridTable/GridTable";
import Checkbox from "pages/_components/Checkbox";
import TextField from "pages/_components/fields/TextField";

const DDJJSubOptionRow = ({ formId, option, subOption, row, hasInput = false, className = "" }) => (
    <GridTable.Data
        columnStart={2}
        columnWidth={10}
        className={className}
        rowStart={row}
        key={`${option}-${subOption}`}>
        <div className="ddjj-inline-checkbox">
            <Field name={`${option}.${subOption}`}>
                {({ field, form }) => {
                    const handleCheckboxChange = (checked) => {
                        const currentGroup = form.values[option] || {};
                        const updated = Object.keys(currentGroup).reduce((acc, key) => {
                            acc[key] = key === subOption ? checked : false;
                            return acc;
                        }, {});

                        form.setFieldValue(option, updated);
                    };

                    return (
                        <Checkbox
                            {...field}
                            idForm={formId}
                            name={field.name}
                            checked={field.value}
                            labelText={`${formId}.${field.name}.label`}
                            labelClassName="ddjj-inline-content"
                            onChange={handleCheckboxChange}
                        />
                    );
                }}
            </Field>

            {hasInput && (
                <Field
                    component={TextField}
                    idForm={formId}
                    name={`${option}.${subOption}.field`}
                    hideLabel
                    hidePlaceholder
                />
            )}
        </div>
    </GridTable.Data>
);

export default DDJJSubOptionRow;
